<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<!--
 * @Description: PC端 IM 即时通讯组件
 * @Date: 2022-01-25 16:05:22
 * @LastEditTime: 2022-02-17 16:09:29
-->
<template>
  <div class="im-message-container">
    <div class="content-top-chat" ref="box"
      @mouseenter="mouseenter"
      @mousemove="mousemove"
      @mouseleave="mouseleave"
    >
      <div class="out" v-if="messageList.length === 0 && chatRoomEnable">快来互动吧！</div>
      <div class="out disabled-tips" v-if="!chatRoomEnable">聊天室暂时关闭</div>

      <div class="single-message" v-for="(message, index) in messageList" :key="index"
           v-if="
            !message.hasSensword &&
            message.state == 'success' ||
            message.state == 'fail' ||
            (message.state == 'hide' && isAdminstator)"
           :class="message.userID === userInfo.userId ? 'oneself' : ''">
        <div class="message-info">
          <span class="message-time" v-if="message.userID === userInfo.userId">{{ getMessageTime(message) }}</span>
          <span class="user-name">{{ getUserNick(message) }}</span>
          <span class="message-time" v-if="message.userID !== userInfo.userId">{{ getMessageTime(message) }}</span>
        </div>
        <div class="message-content-container">
          <div class="message-send-fail" v-if="message.userID === userInfo.userId && message.state === 'fail'"
              title="点击重发" @click="reSendMessage(message)">
            <svg-icon class="icon-style" icon-name="error"></svg-icon>
          </div>

          <div class="message-send-restore" v-if="isAdminstator && message.userID == userInfo.userId && message.state === 'hide'"
               title="还原" @click="restoreMessage(message)">
            <svg-icon class="icon-style" icon-name="restore"></svg-icon>
          </div>


          <div class="message-content" @contextmenu="contextmenu(message)">
            <span v-for="(item, index) in message.renderContent" :key="index">
              <span v-if="item.name === 'text'" :key="message.id + '_' + index" v-html="item.content"></span>
              <img class="message-icon" v-else-if="item.name === 'emojiIcon'" :src="item.src"
                   :key="message.id + '_' + index"/>
            </span>
          </div>


          <div class="message-send-fail" v-if="message.userID !== userInfo.userId && message.state === 'fail'"
              title="点击重发" @click="reSendMessage(message)">
            <svg-icon class="icon-style" icon-name="error"></svg-icon>
          </div>

          <div class="message-send-restore" v-if="isAdminstator && message.userID !== userInfo.userId && message.state === 'hide'"
               title="还原"  @click="restoreMessage(message)">
            <svg-icon class="icon-style" icon-name="restore"></svg-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="content-bottom">
      <div class="content-bottom-feel">
        <el-popover placement="top" trigger="click" v-model="popoverVisible">
          <div class="emojis">
            <div class="emoji" v-for="emoji in emojiName" :key="emoji" @click="chooseEmoji(emoji)"><img
                :src="emojiUrl + emojiMap[emoji]"/></div>
          </div>
          <span class="icon-button" slot="reference">
            <svg-icon class="emoji-icon" icon-name="emoji"></svg-icon></span>
        </el-popover>

        <!-- <el-upload class="imgUploadPc" action="/live/uploadCover" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                   :with-credentials="true" :multiple="false" :limit="1" :show-file-list="false" :file-list="fileList"
                   :data="imgUploadPreFixData" :before-upload="handleImgBeforeUpload"
                   :on-success="handleImgUploadSuccess"><i class="el-icon-picture"></i></el-upload> -->

      </div>
      <div class="content-bottom-input">
        <textarea class="input" ref="input" type="text" v-model="inputMsg" :placeholder="inputPlaceHolder"
                  @keyup.enter="handleSendMsg" :disabled="isLiveEnded || showLoginAttention"
                  required="required"></textarea>
      </div>
      <div class="login-attention" v-if="showLoginAttention">
        <span>当前为游客身份，请通过</span>
          <a class="login-link" @click="handleLogin('pc')">APP访问</a>
        </div>

      <context-menu id="context-menu" ref="allMenu">
        <li class="ctx-item" @click="hideMsg(currentNode)">隐藏</li>
        <li class="ctx-item" @click="deleteMsg(currentNode)">删除</li>
      </context-menu>
    </div>
  </div>
</template>

<script>
import tim from './tim.js'

export default {
  name: 'imMessage',
  mixins: [tim],
}
</script>

<style lang="stylus" scoped>
.im-message-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .content-top-chat {
    flex-grow: 1;
    width: 100%;
    height: 330px;
    margin: 10px 0;
    overflow: auto;
    margin: 10px 0;
    border-radius: 10px;
    padding: 14px 22px;
    color: $fontColor;
    font-size: 14px;
    position: relative;
    margin: 0;

    .out {
      color: #999;
      // margin 50% auto
      text-align: center;
      margin: 0 !important;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .single-message {
      width: 100%;
      text-align: left;

      .message-info {
        height: 30px;
        line-height: 30px;
        color: $grayFontColor;
        font-size: 14px;

        .user-name {
          padding-right: 12px;
        }
      }

      .message-content-container {
        display: flex;
        align-items: center;

        .message-content {
          width: 80%;
          min-width: 260px;
          // background-color rgba(223,223,223,0.05);
          background-color: #fff;
          padding: 8px 12px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          word-break: break-all;

          span {
            display: inline-block;
            vertical-align: center;

            .message-icon {
              width: 20px;
              height: 20px;
              vertical-align: middle;
            }
            p {
              margin: 0;
              line-height: 1.5;
              letter-spacing: 1px;
            }
          }
        }

        .message-send-restore, .message-send-fail {
          width: 24px;
          height: 24px;
          margin-left: 10px;
          cursor: pointer;
          display: flex;
          align-items: center;
        }

        .message-send-restore {
          path {
            fill: red;
          }
        }
      }

      &:last-of-type {
        margin-bottom: 10px;
      }

      &.oneself {
        text-align: right;

        .message-info {
          .user-name {
            padding-right: 0;
            padding-left: 12px;
          }
        }

        .message-content-container {
          justify-content: flex-end;

          .message-send-restore, .message-send-fail {
            margin-left: 0;
            margin-right: 10px;
          }
        }
      }
    }
  }

  .divider {
    width: 100%;
    height: 2px;
    background-color: $lineColor;
  }

  .content-bottom {
    width: 100%;
    padding: 12px;
    height: 200px;
    position: relative;

    div.content-bottom-feel {
      width: 100%;
      text-align: left;

      .icon-button {
        cursor: pointer;

        .emoji-icon {
          width: 24px;
          height: 24px;
          fill: $emojiIconColor;
          margin-right: 10px;
        }
      }

      .imgUploadPc {
        display: inline-block;
        font-size: 24px;
        color: #666;
      }
    }

    div.content-bottom-input {
      text-align: left;
      position: relative;
      margin: 4px auto 0;

      .input {
        color: $fontColor;
        top: 0;
        right: 0;
        width: 100%;
        height: 140px;
        padding: 4px;
        background-color: $IMThemeColor;
        font-size: 16px;
        border: none;
        outline: none;
        resize: none;
      }
    }

    .send-btn {
      width: 53px;
      height: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 16px;
    }

    .login-attention {
      width: 100%;
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);

      .login-link {
        cursor: pointer;
      }
    }
  }
}

.emojis {
  height: 170px;
  max-width: 400px;
  overflow: scroll;

  .emoji {
    height: 30px;
    width: 30px;
    float: left;
    box-sizing: border-box;

    img {
      width: 30px;
      height: 30px;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "Chat now": "Chat now！",
    "Type a message": "Type a message",
    "Current visitor status": "当前为游客身份，请先",
    "login": "登录",
    "Live room does not exist": "Live room does not exist",
    "join Group fail": "Join Group fail, please refresh."
  },
  "zh": {
    "Chat now": "快来互动吧！",
    "Type a message": "说点什么",
    "Current visitor status": "当前为游客身份，请先",
    "login": "登录",
    "Live room does not exist": "直播间不存在",
    "join Group fail": "加入直播聊天群失败，请刷新重试"
  }
}
</i18n>
